import { render, staticRenderFns } from "./TuuzRight.vue?vue&type=template&id=6aa3b21a"
import script from "./TuuzRight.vue?vue&type=script&lang=js"
export * from "./TuuzRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports